import proxyInstance from "src/config/api/proxyInstance";

export const logout = () => proxyInstance.post("users/auth/logout");
